// src/store/rootReducer.js
import { combineReducers } from 'redux'
import userReducer from './userSlice'
import sidebarReducer from './sidebar/sidebarReducer'
import conversationsReducer from './conversations/conversationsReducer'
import notificationsReducer from './notifications/notificationsReducer'
import languageReducer from './languageSlice'

// Note : l'état temps réel de la messagerie (conversations ouvertes, compteur
// de non-lus) ne vit pas dans Redux mais dans le singleton de
// `hooks/useFloatingMessaging`, lu via `useMessagingUnreadCount`. Les slices
// `messages` et `floatingMessaging` qui doublonnaient cet état ont été
// supprimés : plus aucun lecteur ni écrivain au runtime.
const rootReducer = combineReducers({
  user: userReducer,
  sidebar: sidebarReducer,
  conversations: conversationsReducer,
  notifications: notificationsReducer,
  language: languageReducer, // i18n : current / supported / default (S1)
})

export default rootReducer
